import './ShopPlanBadge.css';
import { FiLayers } from 'react-icons/fi';

const planClassSuffix = (shopPlan) => {
    if (!shopPlan) {
        return 'base';
    }
    return shopPlan.toLowerCase().replace(/_/g, '-');
};

const ShopPlanBadge = ({
    shopPlan,
    shopPlanDisplayName,
    currentShopBranchCount,
    maxShopBranches,
    showUsage = false,
    variant = 'pill',
}) => {
    const displayName = shopPlanDisplayName || shopPlan;
    if (!displayName) {
        return null;
    }

    const planSuffix = planClassSuffix(shopPlan);
    const usageText =
        showUsage &&
        maxShopBranches != null &&
        currentShopBranchCount != null
            ? `${currentShopBranchCount} de ${maxShopBranches} sucursales`
            : null;

    const label = `Plan ${displayName}`;

    return (
        <span
            className={`shop-plan-badge shop-plan-badge--${variant} shop-plan-badge--plan-${planSuffix}`}
        >
            <FiLayers size={15} aria-hidden className="shop-plan-badge__icon" />
            <span className="shop-plan-badge__text">
                <strong>{label}</strong>
                {usageText ? ` · ${usageText}` : ''}
            </span>
        </span>
    );
};

export default ShopPlanBadge;
